module.exports = __webpack_public_path__ + "static/media/Maltings-Antiqua.425778df.jpg";